import React from 'react';
import LegalDocument from './LegalDocument';
import { SUPPORT_EMAIL } from '../config/emailjs';

const INTRO =
  'Acá explicamos qué información tratamos cuando usás Contsuite, con qué fin y cómo podés ejercer tus derechos. Buscamos transparencia sin abrumarte con tecnicismos.';

const SECTIONS = [
  {
    id: 'responsable',
    heading: '1. Responsable',
    paragraphs: [
      'Contsuite (contsuite.com.ar) es responsable del tratamiento de los datos personales necesarios para prestar el servicio de gestión y cobranzas descrito en la aplicación.',
    ],
  },
  {
    id: 'datos',
    heading: '2. Datos que recopilamos',
    paragraphs: ['Según cómo uses la plataforma, podemos tratar:'],
    bullets: [
      'Datos de cuenta: nombre, email, teléfono, preferencias (por ejemplo tema claro/oscuro).',
      'Datos de negocio que cargás: clientes, ventas, gastos, cobranzas, notas y archivos que adjuntes.',
      'Datos técnicos: logs, dirección IP, tipo de dispositivo y navegador, para seguridad y diagnóstico.',
      'Si iniciás sesión con Google: identificador y email según los permisos que autorices en Google.',
    ],
  },
  {
    id: 'finalidad',
    heading: '3. Finalidad',
    paragraphs: [
      'Usamos tus datos para operar la plataforma según las funciones que elijas.',
      'No vendemos ni alquilamos tu base de clientes a terceros con fines comerciales.',
    ],
    bullets: [
      'Crear y mantener tu cuenta, autenticarte y aplicar límites de plan.',
      'Mostrar tu información en el panel, generar reportes y packs para el contador.',
      'Enviar emails transaccionales (recupero de clave, alertas que actives).',
      'Mejorar estabilidad y soporte cuando nos escribís.',
    ],
  },
  {
    id: 'almacenamiento',
    heading: '4. Almacenamiento',
    paragraphs: [
      'Los datos se alojan en infraestructura en la nube (por ejemplo Supabase/Postgres en regiones con estándares de seguridad). Las comunicaciones entre tu navegador y nuestros servidores usan HTTPS.',
      'Conservamos la información mientras mantengas la cuenta activa. Si hay un fallo de cobro de la suscripción, aplicamos **15 días de gracia** con acceso de **solo lectura** (podés ver y exportar; no crear ni modificar registros operativos). Tras ese plazo, el acceso a la app se suspende pero **no borramos** tus datos de inmediato: los retenemos hasta **12 meses** desde la suspensión, con avisos por email antes de una eventual baja de la cuenta. Al regularizar el pago en Mercado Pago recuperás el acceso completo sin pérdida de información.',
    ],
  },
  {
    id: 'derechos',
    heading: '5. Tus derechos',
    paragraphs: [
      `Podés solicitar acceso, rectificación o eliminación de tu cuenta escribiendo a ${SUPPORT_EMAIL}. Te responderemos en un plazo razonable. Algunos datos pueden conservarse anonimizados o en respaldo por obligación legal.`,
    ],
  },
  {
    id: 'cookies',
    heading: '6. Cookies y localStorage',
    paragraphs: [
      'Usamos almacenamiento local del navegador (localStorage) para mantener tu sesión, tokens de autenticación y preferencias de interfaz. No usamos cookies de publicidad de terceros en el núcleo del producto.',
    ],
  },
  {
    id: 'cambios',
    heading: '7. Cambios',
    paragraphs: [
      'Podemos actualizar esta política para reflejar cambios en el servicio o en la normativa. Publicaremos la nueva fecha arriba. Te recomendamos revisar esta página de vez en cuando.',
    ],
  },
];

export default function Privacidad() {
  return (
    <LegalDocument
      variant="privacy"
      title="Política de privacidad"
      updated="septiembre 2026"
      intro={INTRO}
      sections={SECTIONS}
    />
  );
}
